// extracted by mini-css-extract-plugin
export var header = "_xh-1";
export var maskBottom = "_xh-6";
export var maskMiddle = "_xh-7";
export var maskTop = "_xh-5";
export var root = "_xh-0";
export var scrollDownButton = "_xh-3";
export var scrollDownButtonHidden = "_xh-4";
export var viewport = "_xh-2";